import React, { FC, useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { TEXTS } from "../../constants";
import { VisibilityContext } from "../../context";
import FlagIcon from "../../utils/FlagIcon";
import ClearFilters from "../Buttons/ClearFilters";
import ChipsContainer from "../Filters/ChipsContainer";
import ShowFilters from "../Buttons/ShowFilters";
import FilterNavigation from "../Filters/Navigation";
import Table from "../Table";
import FilterMenu from "../Filters/Menu";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    "@global tbody tr:nth-child(odd)": {
      background: "#EEF3F8",
    },
    "@global tbody tr:nth-child(even)": {
      background: "#FFF",
    },
    materialTableToolbar: { "& h6": { color: theme.palette.primary.main, fontWeight: 900 } },
    content: {
      padding: 16,
      marginTop: 24,
    },
    loading: {
      minHeight: 12,
      marginBottom: "12px",
    },
    headerContainer: {
      marginBottom: "1rem",
    },
    headerText: {
      color: theme.palette.primary.dark,
      display: "inline",
      marginLeft: "12px",
    },
    clearFiltersButton: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row-reverse",
    },
    dataContent: {
      filter: "brightness(0.85)",
    },
    filterMenu: {
      position: "absolute",
      zIndex: 1200,
    },
    filterMenuContainer: {
      position: "relative",
    },
    blurDisable: {
      filter: "blur(3px)",
      pointerEvents: "none",
    },
    disable: {
      pointerEvents: "none",
    },
  })
);

const ClinicalPipeline: FC = () => {
  const classes = useStyles();

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  return (
    <div>
      <Grid container>
        <Grid item xs={6} className={classes.headerContainer}>
          <FlagIcon code={"us"} size={"lg"} />
          <Typography className={classes.headerText} variant="h1">
            {TEXTS.TITLE}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.clearFiltersButton}>
          <ClearFilters />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={3} className={classes.filterMenuContainer}>
          <ShowFilters />
        </Grid>
        <Grid item xs={9} className={visibilityContext.menu ? classes.disable : ""}>
          <ChipsContainer />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid className={classes.filterMenu} item xs={3}>
          <FilterMenu />
        </Grid>
        <Grid item xs={12} className={visibilityContext.menu ? classes.blurDisable : ""}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FilterNavigation />
            </Grid>
            <Grid item xs={12}>
              <Table />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ClinicalPipeline;
